// Kept in a separate file following the reactQueryKeys convention so these keys
// can be reused for cache invalidation/removal (e.g. queryClient.invalidateQueries)
// from mutation hooks or other parts of the app without coupling to useHotelSearch.

export const all = ['hotelSearch'] as const
export const search = (
  placeName: string,
  region?: string,
  checkIn?: string,
  checkOut?: string,
  flexibleMonths?: string,
  flexibleNights?: string,
  placeId?: string,
  propertyId?: string,
  typeaheadId?: string,
  occupancies?: Array<App.Occupants>,
  filters?: App.OfferListFilters,
) =>
  [...all, placeName, region, checkIn, checkOut, flexibleMonths, flexibleNights, placeId, propertyId, typeaheadId, occupancies, filters] as const
